import React from 'react';
import { TextField as MuiTextField } from '@mui/material';

interface TextFieldProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  type?: 'text' | 'password';
  maxLength?: number;
  autoFocus?: boolean;
}

const TextField = ({
  value,
  onChange,
  label,
  type = 'text',
  maxLength,
  autoFocus = false
}: TextFieldProps) => {
  return (
    <MuiTextField
      autoFocus={autoFocus}
      margin="dense"
      label={label}
      type={type}
      fullWidth
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value.slice(0, maxLength))}
      inputProps={{ maxLength }}
      InputProps={{
        endAdornment: maxLength ? (
          <span style={{ color: 'text.secondary', marginRight: 8 }}>
            {value.length}/{maxLength}
          </span>
        ) : undefined
      }}
      sx={{ 
        mt: 2, 
        "& .MuiOutlinedInput-root": { 
                "& fieldset": { borderColor: "#1976d2" },
      "&:hover fieldset": { borderColor: "#1976d2" },
      "&.Mui-focused fieldset": { borderColor: "#1976d2" } 
        }, 
        "& .MuiInputLabel-root": { 
          "&.Mui-focused": { color: "#1976d2" } 
        } 
      }}
    />
  );
};

export default TextField; 